export default "__VITE_ASSET__e3fc739d__"